import CaseStudyPage from "@/pages/portfolio/components/CaseStudyPage";

export default function AiCustomerSupportCase() {
  return <CaseStudyPage slug="ai-customer-support-assistant" />;
}